import { UserRole } from '@mobx/interfaces';
import type { ResponsesUserResponse } from '@/shared/api/orval/models';

export interface AuthService {
  id: number | null;
  userData: UserData | ResponsesUserResponse | undefined;
  setAuthData: (data: { userId: number }) => Promise<void>;
  authUser: (phone: string, code: string) => Promise<void>;
  authUserAfterRegistration: (userId: number) => Promise<void>;
  sessionExpired: () => void;
  logout: () => void;
  refreshUserInfo: () => Promise<void>;
  /**
   * Запомнить язык, ТОЛЬКО ЧТО ПРИНЯТЫЙ СЕРВЕРОМ, в данных текущего пользователя.
   *
   * Нужен ровно для того, чтобы кабинет не мигал языком. userData персистится в localStorage,
   * а SettingsStore адаптирует язык реакцией на userData.lang. Не обнови мы поле после
   * сохранения — в персисте осталось бы ПРЕЖНЕЕ значение, и при следующей загрузке страницы
   * человек увидел бы сначала старый язык (из персиста), а через мгновение новый (из ответа
   * сервера). Мигание тем заметнее, чем медленнее сеть
   */
  setUserLang: (lang: string) => void;
  // Сброс полей к initial + очистка persist сессии (иначе старые данные протекают между входами)
  clearSession: () => Promise<void>;
}

export const AuthServiceIdentifier = Symbol.for('AuthService');

export interface UserData {
  id: 0;
  code: string;
  fio: string;
  iin: string;
  phone: string;
  email: string;
  roles: UserRole[];
  /** Язык общения: 'ru' | 'kk' | null — ещё не выбирал. Источник правды для языка кабинета */
  lang?: string | null;
}

export interface LoginData {
  username: string;
  code: string;
}
